import React, { Component } from 'react';
import styled from 'styled-components';
import { media } from '../../helpers/styleConstants';
import { isAutoCreatedEmail } from '../../helpers/stringHelper';
import { connect } from 'react-redux';
import { DynamicWrapper } from '../../components/util/DynamicWrapper';
import { TextField, TextFieldHelperText } from 'rmwc';
import { Text } from '../../components/Text';

import { wlVar } from '../../helpers/whitelabel';

import { claimGuestUser } from '../../actions/userActions';

const StyledAnswerRow = styled.div`
  width: 80%;
`;

const StyledTwoAnswerRow = styled.div`
  width: 80%;

  ${media.tabletPortraitUp`
    display: flex;
    justify-content: space-between;
  `};
`;

const StyledTextField = styled(TextField)`
  width: 100%;

  ${media.tabletPortraitUp`
    width: ${props => (props.half ? '48%' : '100%')};
  `};
`;

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: props.user ? props.user.first_name : '',
      lastName: props.user ? props.user.last_name : '',
      emailAddress: props.user && !isAutoCreatedEmail(props.user.email) ? props.user.email : '',
      phone: props.user ? props.user.phone : '',
      validated: true,
      validationError: '',
    };
  }

  componentWillReceiveProps(props) {
    if (props.user) {
      this.setState({
        firstName: props.user.first_name,
        lastName: props.user.last_name,
        emailAddress: isAutoCreatedEmail(props.user.email) ? '' : props.user.email,
        phone: props.user.phone,
      });
    }
  }

  _onContinue = () => {
    const { onContinue } = this.props;
    const { firstName, lastName, emailAddress, phone } = this.state;

    if (!this.validateWithFeedback()) {
      return;
    }

    let phoneNumeric = phone ? phone.replace(/\D/g, '') : '';
    if (phoneNumeric.length === 11) {
      // make sure to only take the last 10 digits
      phoneNumeric = phoneNumeric.slice(-10);
    }

    this.props.claimGuestUser(firstName, lastName, emailAddress, phoneNumeric, '').then(onContinue);
  };

  _canContinue() {
    const { emailAddress, firstName, validated } = this.state;

    // taken from http://emailregex.com/
    const re = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+(?:\.[a-zA-Z0-9-]+)*$/;

    return firstName && emailAddress && re.test(emailAddress) && validated;
  }

  _onBack = () => {
    this.props.onBack();
  };

  onChange = (evt, field) => {
    if (field === 'phone' && !this.state.validated) {
    }
    this.setState({ [field]: evt.target.value }, () => {
      if (!this.state.validated) {
        this.validateWithFeedback();
      }
    });
  };

  validateWithFeedback = () => {
    const { phone } = this.state;
    const phoneNumeric = phone ? phone.replace(/\D/g, '') : '';
    if (
      phoneNumeric.length === 0 ||
      phoneNumeric.length === 10 ||
      (phoneNumeric.length === 11 && phoneNumeric.charAt(0) === '1')
    ) {
      this.setState({ validated: true, validationError: '' });
      return true;
    } else {
      this.setState({
        validated: false,
        validationError: 'Error: Please make sure that your phone number contains 10 digits or skip it for now.',
      });
      return false;
    }
  };

  render() {
    const { wrapper, onBack, qna_hash, user } = this.props;

    return (
      <DynamicWrapper
        style={{ width: '100%' }}
        wrapper={wrapper}
        onContinue={this._onContinue}
        onBack={this._onBack}
        canContinue={this._canContinue()}
      >
        <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
          <Text use="headline6">Your Name</Text>
        </div>
        <StyledTwoAnswerRow className="mb-3">
          <StyledTextField
            half
            id="firstName"
            className="m-0"
            onChange={e => this.onChange(e, 'firstName')}
            value={this.state.firstName}
            label="First Name"
          />
          <StyledTextField
            half
            id="lastName"
            className="m-0"
            onChange={e => this.onChange(e, 'lastName')}
            value={this.state.lastName}
            label="Last Name"
          />
        </StyledTwoAnswerRow>
        {wlVar('asks_for_phone_number') && (
          <StyledAnswerRow>
            <StyledTextField
              id="phone"
              onChange={e => this.onChange(e, 'phone')}
              value={this.state.phone}
              label="Phone"
              onBlur={this.validateWithFeedback}
            />
          </StyledAnswerRow>
        )}
        {isAutoCreatedEmail(user.email) && (
          <StyledAnswerRow>
            <StyledTextField
              id="emailAddress"
              className="m-0"
              onChange={e => this.onChange(e, 'emailAddress')}
              value={this.state.emailAddress}
              label="Email Address"
            />
            <TextFieldHelperText className="mb-4" persistent>
              So that you can securely save a copy of your results
            </TextFieldHelperText>
          </StyledAnswerRow>
        )}
        <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
          <Text use="body" style={{ color: 'red' }}>
            {this.state.validationError}
          </Text>
        </div>
      </DynamicWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
  };
}

export default connect(mapStateToProps, { claimGuestUser })(Contact);
